import './RadioGroupInput.scss';

import { Radio } from 'antd';
import type { RadioGroupButtonStyle, RadioGroupOptionType } from 'antd/es/radio';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputHeader
} from '../_common';

interface RadioGroupInputProps {
  name: string;
  label?: string;
  options?: RegisterOptions;
  disabled?: boolean;
  required?: boolean;
  optionType?: RadioGroupOptionType;
  buttonStyle?: RadioGroupButtonStyle;
  items: { label: string; value: string }[];
  inputNote?: InputNoteConfig;
  customOnChange?: (newValue: string, oldValue: string) => void;
  hideLabel?: boolean;
}

const RadioGroupInput = ({
  name,
  disabled,
  label,
  options,
  required,
  optionType = 'button',
  items,
  buttonStyle,
  inputNote,
  customOnChange,
  hideLabel
}: RadioGroupInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;
  return (
    <div className={getHookGroupClass(label, 'RadioGroupInput')}>
      {!hideLabel && renderHookInputHeader(name, label, required, inputNote)}
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <Radio.Group
            {...field}
            id={name}
            disabled={disabled}
            className={getHookFieldClass(isTouched, invalid)}
            optionType={optionType}
            buttonStyle={buttonStyle}
            options={items}
            onChange={(e) => {
              if (customOnChange) {
                customOnChange(e.target.value, field.value);
              } else {
                field.onChange(e.target.value);
              }
            }}
          />
        )}
      />

      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default RadioGroupInput;
